import { IRankingChangeTableChangeBubbleProps } from "@/pages/dashboard/pages/changeAnalysis/components/RankingChangeTable/components/RankingChangeTableChangeBubble/type";
import React, { FC } from "react";
import './index.scss';
import UpAndDown from "@/pages/dashboard/components/UpAndDown";
import { getUpAndDownStatus } from "@/pages/dashboard/utils/utils";

export const RankingChangeTableChangeBubble: FC<IRankingChangeTableChangeBubbleProps> = (props) => {
  const { record } = props;
  const {
    compareRate = '',
    baseDate = '',
    baseDateRank = '',
    compareDate = '',
    compareDateRank = '' } = record || {};

  return (
    <div className="dbd-ranking-cell__hover">
      <div className="dbd-ranking-cell__hover__title">Period Change</div>
      <div className="dbd-ranking-cell__hover__row">
        <span className="dbd-ranking-cell__hover__label">Change</span>
        <UpAndDown
          data={`${((Number(compareRate) || 0) * 100).toFixed(2)}%`}
          status={getUpAndDownStatus(compareRate, false)}
        />
      </div>
      <div className="dbd-ranking-cell__hover__flex">
        <div className="dbd-ranking-cell__hover__row dbd-ranking-cell__hover__row__flex">
          <span className="dbd-ranking-cell__hover__date">{compareDate}</span>
          <div className="dbd-ranking-cell__hover__divider"></div>
          <span className="dbd-ranking-cell__hover__date">{baseDate}</span>
        </div>

        <span className="dbd-ranking-cell__hover__vs">VS</span>

        <div className="dbd-ranking-cell__hover__row dbd-ranking-cell__hover__row__flex">
          <span className="dbd-ranking-cell__hover__rank">{compareDateRank}</span>
          <div className="dbd-ranking-cell__hover__divider"></div>
          <span className="dbd-ranking-cell__hover__rank">{baseDateRank}</span>
        </div>
      </div>
    </div>
  );
};
